import { render, staticRenderFns } from "./EmailHelpdeskIntegrationForm.vue?vue&type=template&id=601bac9d&"
import script from "./EmailHelpdeskIntegrationForm.vue?vue&type=script&lang=js&"
export * from "./EmailHelpdeskIntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports